import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh_CN'
import enUS from './locales/en_US'
import trTR from './locales/tr_TR'
import ruRU from './locales/ru_RU' // ✅ 引入俄语

// 从环境变量中获取默认语言，若无则默认为中文
const defaultLocale = process.env.VUE_APP_DEFAULT_LOCALE || 'zh-cn'

// 获取缓存中的语言
const cachedLocale = localStorage.getItem('localeLanguage')

// 如果缓存中没有语言，则将默认语言存入缓存
if (!cachedLocale) {
  localStorage.setItem('localeLanguage', defaultLocale)
}

// 每次刷新页面使用缓存的语言
const currentLocale = localStorage.getItem('localeLanguage')

const i18n = createI18n({
  legacy: false,
  locale: currentLocale,
  messages: {
    'zh-cn': zhCN,
    'en-us': enUS,
    'tr-tr': trTR,
    'ru-ru': ruRU, // ✅ 注册俄语
  },
})

// 设置页面标题
document.title = i18n.global.t('site.name')

export default i18n
